import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => {
	return {
		root: {},
		moreBox: {
			'& .MuiTypography-subtitle1': {
				fontSize: '2.4rem',
				lineHeight: '3.2rem',
				marginRight: 20,
				color: '#828282',
				fontWeight: 500,
			},
			'& svg': {
				color: '#828282',
			},
		},
		showMore: {},
		menu: {
			'& .MuiPaper-root': {
				minWidth: 240,
			},
			'& .MuiMenuItem-root': {
				textTransform: 'capitalize',
				fontWeight: 600,
				fontSize: '1.6rem',
				lineHeight: '2rem',
				color: '#333333',
				paddingTop: 12,
				paddingBottom: 12,
				paddingLeft: 20,
			},
		},
		action: {
			width: '100%',
			height: '100%',
			backgroundColor: '#F2F2F2',
		},
		label: {
			width: '100%',
			height: '100%',
			display: 'flex',
			alignItems: 'center',
			paddingLeft: 10,

			'& .MuiTypography-root': {
				fontWeight: 600,
				fontSize: '1.6rem',
				lineHeight: '2.4rem',
			},
			[theme.breakpoints.up('sm')]: {
				paddingLeft: 30,
				'& .MuiTypography-root': {
					fontWeight: 500,
					fontSize: '2.4rem',
					lineHeight: '3.2rem',
				},
			},
			[theme.breakpoints.up('lg')]: {
				paddingLeft: 40,
			},
		},
		media: {
			position: 'absolute',
			bottom: 0,
			right: 0,

			backgroundPosition: 'center right',
			height: '100%',
			width: 'auto',
			objectFit: 'contain',
		},
	};
});
